
import { useEffect, useState } from "react";
import "./Dashboard.css";
import useAxiosInstance from "../../../Utilities/Hooks/useAxiosInstance";
import EventDetails from "./EventDetails/EventDetails";
import OrderAmountDetails from "./OrderAmountDetails/OrderAmountDetails";
import DashboardWrappper from "./DashboardWrappper";

function Dashboard() {
  const axiosInstance = useAxiosInstance()

  const [data, setData] = useState({})

  useEffect(() => {
    async function setAndFetchEventsInfo() {
      const { data } = await axiosInstance.get("/getDashboardInfo")
      setData(data)
    }
    setAndFetchEventsInfo()
  }, [axiosInstance])

  return (

    <DashboardWrappper >
      <EventDetails nowSellingEvents={data?.nowSellingEvents} />
      <OrderAmountDetails data={data} />
    </DashboardWrappper>

  );
}

export default Dashboard;
